import { Link } from "react-router-dom";
import { categories } from "@/mocks/entries";
import { siteConfig } from "@/mocks/site";

const quickLinks = [
  { label: "首页", href: "/" },
  { label: "事件词条库", href: "/entries" },
  { label: "关于我们", href: "/about" },
  { label: "联系我们", href: "/contact" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-50">
      <div className="px-4 py-12 md:px-10 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-book-2-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold">{siteConfig.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-100/80">
              {siteConfig.tagline}。按背景、时间线与完整记录梳理每一个瓜条，倡导理性看待、不信谣不传谣。
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold tracking-wider text-accent-300">快速导航</h2>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-secondary-100/80 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold tracking-wider text-accent-300">话题分类</h2>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/entries?cat=${cat.slug}`}
                    className="text-sm text-secondary-100/80 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold tracking-wider text-accent-300">内容联系</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-secondary-100/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5" />
                <span className="break-all">{siteConfig.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-chat-3-line mt-0.5" />
                <span className="break-all">{siteConfig.workEmail}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5" />
                <span>词条更新：每日 09:00 与 21:00</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-secondary-950 transition-colors hover:bg-accent-400"
            >
              提交更正与建议
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-700/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-100/60">
            © 2026 {siteConfig.name} · 站内词条为示例性内容，用于演示词条结构，不针对任何真实人物或机构。
          </p>
          <p className="text-xs text-secondary-100/60">
            倡导理性讨论 · 拒绝人身攻击 · 不信谣不传谣
          </p>
        </div>
      </div>
    </footer>
  );
}